import { IScreen } from "shared/interfaces";
import { Main } from "screens/main";
import { LoaderService, PopupsService, DiscountPopupService, LanguageService } from "shared/services";
import { OriginSize } from "shared/origin";
import gsap from "gsap";
import { MapConfig, LevelsConfig, FontsConfig, SettingConfig } from "shared/config";
import { MapElement } from "shared/model";
import { TextHelper, PreloaderHelper } from "shared/helpers";
import { Game } from "screens/game/game";
import { GameViewStorage, MapStorage } from "shared/storages";
import { EventBus } from "shared/emmiter";
import { Container, Sprite, Text } from "pixi.js";

export class MapScreen implements IScreen {
    private static _instance: MapScreen = null;

    static get instance(): MapScreen {
        if (MapScreen._instance === null) {
            MapScreen._instance = new MapScreen();
        }
        return MapScreen._instance;
    }

    public name: string = 'map_screen';
    public screen: PIXI.Container;
    public map: PIXI.Container;
    public lastLevel: number;
    public isBtnCreate: boolean = false;
    public plus: number = 0;

    private lastElement: Container;
    private mapElements: PIXI.Container;
    private popups;
    private arrowSize = {
        small: {
            width: 45,
            height: 45,
        },
        big: {
            width: 45,
            height: 140,
        }
    };
    private spriteHeight: number = 0;
    private mouseData = {
        start: 0,
        lastPoint: 0,
        position: 0,
        shift: 900,
        isMouseOut: false,
        isCanMove: false,
        isAnim: false,
        isCanCallAnim: true,
        side: null,
        speed: 0,
        offset: {
            top: null,
            bottom: null,
        },
    }

    public init(level: any): void {
        console.log('map init ::');
        
        this.mouseData = {
            start: 0,
            lastPoint: 0,
            position: 0,
            shift: 600,
            isMouseOut: false,
            isCanMove: false,
            isAnim: false,
            isCanCallAnim: true,
            side: null,
            speed: 0,
            offset: {
                top: null,
                bottom: null,
            },
        }
        this.screen = new PIXI.Container();
        this.mapElements = new PIXI.Container;
        this.mapElements.name = 'map_elements';
        this.screen.name = this.name;
        Main.instance.app.stage.addChild(this.screen);
        GameViewStorage.setIsMap(true);
        PopupsService.init();
        this.addMap();
        this.showMapMenu();
        this.goBackEvent();
        this.discountEvent();

        this.showMapBtn();
        // this.moveMapToLevel();
    }

    private showMapMenu(): void {
        document.getElementById('blackout_substate').style.display = 'none';

        const menu = document.getElementById('mapMenu');
        menu.style.display = 'flex';
    }

    private showMapBtn(): void {
        const btn = document.getElementById('mapBtn');
        btn.style.display = 'flex';

        const levelText = document.getElementById('mapBtnLevel');
        levelText.innerHTML = `${this.lastLevel}`;

        const startBtn = document.getElementById('mapBtn_btn');

        if (!this.isBtnCreate) {
            startBtn.addEventListener('click', () => {
                const level = LevelsConfig.levels[this.lastLevel];
                const user = JSON.parse(localStorage.getItem('mbny_game_user'));
                const userLevels = user.levels;
                if (userLevels[this.lastLevel].score > 0) {
                    return;
                }

                //@ts-ignore
                if (dataLayer) {
                    //@ts-ignore
                    dataLayer.push({
                        'event': 'uaevent',
                        'ecommerce': undefined,
                        'eventCategory': 'match the ink game',
                        'eventAction': 'select',
                        'eventLabel': `play::${this.lastLevel}`,
                    })
                }

                Main.instance.startGame({ num: this.lastLevel, type: level.type });
                Main.instance.app.stage.removeChild(this.screen);

                btn.style.display = 'none';

                this.isBtnCreate = true;
            })

        }
    }


    private goBackEvent(): void {
        const backBtn = document.getElementById('mapMenu_back');
        backBtn.addEventListener('click', () => {
            this.hide();

            const main = document.getElementById('main');
            const mainMenu = document.getElementById('main_page');
            const app = document.getElementById('app');
            const blackoutSubstate = document.getElementById('blackout_substate');
            const btn = document.getElementById('mapBtn');
            btn.style.display = 'none';
            blackoutSubstate.style.display = 'none';
            mainMenu.style.display = 'flex';
            main.style.display = 'flex';
            app.style.display = 'none';
        });
    }

    private discountEvent(): void {
        const btn = document.getElementById('MM_discount');
        btn.addEventListener('click', () => {
            DiscountPopupService.show(false, false);
        });
    }

    private addMap(): void {
        const container = new PIXI.Container();
        container.name = 'map';
        let spriteHeight;

        for (let i = 0; i < 4; i++) {
            const sprite = new PIXI.Sprite(LoaderService.getResource(`map_${i + 1}`).texture);
            sprite.y = MapConfig.mapPartHeight * i;
            sprite.renderable = true;
            spriteHeight = sprite.height;
            this.spriteHeight = sprite.height;
            container.addChild(sprite);
        }
        
        // sprite.height = OriginSize.height * 5;

        // container.addChild(sprite);

        // container.height = spriteHeight * 4;
        // container.y = (-spriteHeight * 4) + (OriginSize.height + MapStorage.plus);
        container.renderable = true;
        this.screen.addChild(container);
        this.map = container;

        this.mouseData.offset.bottom = 0;
        this.mouseData.offset.top = this.map.height - OriginSize.height;
        this.map.y = -container.height + MapStorage.screenHeight;

        EventBus.emmiter.on('plus_map', () => {
            
            this.map.y = -container.height + MapStorage.screenHeight;
            this.setPositionMap();
        });
        MapStorage.map = container;
        this.addInteractive();
        this.addElements();
        this.setPositionMap();
        this.mapElements.y = this.mapElements.y - 500;
    }

    private moveMapToLevel(): void {
        let lastLevel = this.lastLevel;

        if (lastLevel) {
            this.lastLevel = MapStorage.lastLevel;
            lastLevel = this.lastLevel;
        }

        const elements = MapConfig.elements;
        const level = elements[lastLevel];

        if (!this.map) {
            this.map = MapStorage.map;
        }
        const originY = this.map.y;

        const pos = level.y - OriginSize.height / 2;

        if (-pos > originY) {
            this.map.y = -pos;
        } else if (SettingConfig.isMobile) {
            // this.map.y = -3100;
        }
        // if (dif < OriginSize.height / 2) {
        //     this.map.y = -(level.y - OriginSize.height / 2);

        // }
    }

    private addInteractive(): void {
        const body = document.getElementsByTagName('body')[0];
        const map = this.map;
        map.interactive = true;

        this.map.on('pointerdown', (e) => {
            this.startMove(e);
        });
        this.map.on('pointerup', (e) => {
            this.endMove(e);
        });
        this.map.on('pointermove', (e) => {
            this.move(e);
        });
        this.map.on('pointerout', (e) => {
            this.outMove(e);
        });
    }

    private startMove(event): void {
        const y = event.data.global.y;

        this.mouseData.start = y;
        this.mouseData.isCanMove = true;
        this.mouseData.isMouseOut = false;
        this.mouseData.lastPoint = y;

        this._renderAll();
    }

    private _renderAll(): void {
        const sprites = this.map.children;
        const elements = this.map.getChildByName('map_elements') as any;
        const elementsChildren = elements.children;
        for (let i = 0; i < sprites.length; i++) {
            const sprite = sprites[i];

            sprite.renderable = true;
        }

        for (let i = 0; i < elementsChildren.length; i++) {
            const element = elementsChildren[i];
            element.renderable = true;

            for (let j = 0; j < element.children.length; j++) {
                const child = element.children[j];

                child.renderable = true;
            }
        }
    }

    private calcSpeed(y: number): number {
        const movementY = Math.abs(this.mouseData.lastPoint - y);
        const speed = 10 * movementY;

        return speed;
    }

    private outMove(event): void {
        if (this.mouseData.isCanMove) {
            this.endMove(event);
        }
    }

    private endMove(event): void {
        this.mouseData.isCanMove = false;
        gsap.killTweensOf(this.map);
        this.mouseData.isCanCallAnim = true;
        const shift = this.mouseData.shift;

        const side = this.mouseData.side;
        let y = this.mouseData.speed;

        if (!this.mouseData.isAnim) {
            return;
        }

        if (this.mouseData.side === 'down') {
            y = this.map.y + shift > 0 ? 0 : this.map.y + shift;

        } else if (this.mouseData.side === 'up') {
            y = this.map.y - shift < -(this.spriteHeight * 4) + (OriginSize.height - MapStorage.plus) ? -(this.spriteHeight * 4) + (OriginSize.height - MapStorage.plus) : this.map.y - shift;
        }

        if (!this.mouseData.isMouseOut) {
            gsap.to(this.map, { y: y, duration: 0.5, ease: 'sine' })
        }

        this.mouseData.isAnim = false;
        this._renderAll();

    }

    private move(event): void {

        if (!this.mouseData.isCanMove) return;
        const y = event.data.global.y;
        const lastPoint = this.mouseData.lastPoint;
        let side;
        if (lastPoint < y) {
            side = "down";
        } else {
            side = "up";
        }
        const speed = this.calcSpeed(y);

        this.mouseData.speed = speed;
        this.mouseData.side = side;
        this.mouseData.lastPoint = y;
        this.mouseData.isAnim = true;
        // if (!this.mouseData.isCanCallAnim) {
        //     return;
        // }
        gsap.killTweensOf(this.map);
        this.anim();

        this.mouseData.isCanCallAnim = false;
    }

    private anim(): void {
        const shift = this.mouseData.shift;
        let y;
        console.log('y ' + this.map.y);
        console.log('total ' + (-(this.spriteHeight * 4) + (OriginSize.height - MapStorage.plus)));
        console.log('plus ' + MapStorage.plus);
        console.log('origin ' + OriginSize.height);

        console.log('spriteHeight ' + this.spriteHeight * 4);


        if (this.map.y <= -(this.spriteHeight * 4) + (OriginSize.height - MapStorage.plus)) {
            return;
        }

        if (this.mouseData.side === 'down') {
            y = this.map.y + shift > 0 ? 0 : this.map.y + shift;
        } else if (this.mouseData.side === 'up') {
            y = this.map.y - shift < -(this.spriteHeight * 4) + (OriginSize.height - MapStorage.plus) ? -(this.spriteHeight * 4) + (OriginSize.height - MapStorage.plus) : this.map.y - shift;
        }

        gsap.to(this.map, {
            y: y, 
            duration: 0.3, 
            ease: 'none', 
            onComplete: () => {
                if (this.mouseData.isAnim) {
                    this.anim();
                }
            },
            onUpdate: () => {
                if (this.map.y <= -(this.spriteHeight * 4) + (OriginSize.height - MapStorage.plus)) {
                    gsap.killTweensOf(this.map);
                    this.map.y = -(this.spriteHeight * 4) + (OriginSize.height - MapStorage.plus)
                }
            }
        })
    }

    private addElements(): void {
        const user = JSON.parse(localStorage.getItem('mbny_game_user'));
        const userLevels = user.levels;
        const elements = MapConfig.elements;
        const points = [];
        const mapElements = [];
        let lastLevel = 1;
        let rewards = 0;
        for (const key in userLevels) {
            if (userLevels.hasOwnProperty(key)) {
                const element = userLevels[key];
                lastLevel = 30;

                if (element.isRevard) {
                    continue;
                }

                if (element.score === 0) {
                    lastLevel = element.level;
                    break;
                }

            }
        }

        this.lastLevel = lastLevel;
        for (let i = 0; i < elements.length; i++) {
            const element = elements[i];
            const level = element.level;
            const container = new MapElement();
            container.x = element.x;
            container.y = element.y;
            container.level = level;
            container.isRevard = false;
            const newPoint = {
                x: element.x,
                y: element.y,
                isLevelComplete: false,
                isGetReward: false,
                isReward: false
            }

            if (element.level && userLevels[level] && userLevels[level].score > 0) {
                newPoint.isLevelComplete = true;
            }

            if (element.isRevard) {
                newPoint.isReward = true;
            }
            // if (element.isRevard && lastLevel > 0 && userLevels[i + 1].score > 0) {
            //     newPoint.isLevelComplete = true;
            //     container.isRevard = true;
            //     lastLevel -= 1;
            //     this.lastLevel = lastLevel;
            // }

            points.push(newPoint)

            if (!element.isRevard && i < lastLevel) {
                const str = level + '';
                if (str.length > 1) {
                    for (let j = 0; j < str.length; j++) {
                        const spriteNum = str[j];

                        const spritesheet = LoaderService.getSpritesheet('map_numbers');

                        const sprite = new PIXI.Sprite(spritesheet.textures[Number.parseInt(spriteNum)]);
                        sprite.zIndex = 70;
                        sprite.scale.set(0.80);

                        if (j === 0) {
                            sprite.x = 40;
                        } else {
                            sprite.x = 105;
                        }

                        if (level > 19 && j !== 0) {
                            sprite.x = 105;
                        }

                        sprite.y = 80;

                        if (i === lastLevel - 1) {
                            sprite.y = sprite.y - 50;
                        }

                        sprite.pivot.set(sprite.width / 2, sprite.height / 2);
                        container.addChild(sprite)
                        
                        
                    }
                    console.log('el.y 00000:');
                } else {
                    const spritesheet = LoaderService.getSpritesheet('map_numbers');

                    const sprite = new PIXI.Sprite(spritesheet.textures[level]);
                    sprite.zIndex = 70;
                    sprite.scale.set(0.80);

                    if (level > 9) {
                        sprite.x = 0;
                    } else {
                        sprite.x = 75;
                    }

                    sprite.y = 90;

                    if (i === lastLevel - 1) {
                        sprite.y = sprite.y - 50;
                    }

                    sprite.pivot.set(sprite.width / 2, sprite.height / 2);
                    container.addChild(sprite);
                    // console.log('el.y :', sprite.y, container.y);
                    this.lastElement = container;
                    // container.y = -this.map.y;
                }


                container.interactive = true;

                container.on('pointerdown', (e) => {

                    const level = LevelsConfig.levels[container.level];
                    const user = JSON.parse(localStorage.getItem('mbny_game_user'));
                    const userLevels = user.levels;
                    if (userLevels[container.level].score > 0) {
                        return;
                    }

                    //@ts-ignore
                    if (dataLayer) {
                        //@ts-ignore
                        dataLayer.push({
                            'event': 'uaevent',
                            'ecommerce': undefined,
                            'eventCategory': 'match the ink game',
                            'eventAction': 'select',
                            'eventLabel': `play::${container.level}`,
                        })
                    }

                    Main.instance.startGame({ num: container.level, type: level.type });
                    Main.instance.app.stage.removeChild(this.screen);

                    this.isBtnCreate = true;
                })
            }

            if (element.isRevard && i < lastLevel) {

                const isClimed = userLevels[`revard_${i}`].isRevardClimed;

                const closeRevard = this.addRevardImage(isClimed);
                closeRevard.name = 'revard_image';
                container.addChild(closeRevard);
                lastLevel += 1;

                if (!isClimed) {
                    container.interactive = true;
                } else {
                    container.interactive = false;
                }

                container.on('pointerdown', (e) => {
                    userLevels[`revard_${i}`].isRevardClimed = true;
                    user.levels = userLevels;

                    localStorage.setItem('mbny_game_user', JSON.stringify(user));

                    container.interactive = false;
                    this.map.interactive = false;
                    closeRevard.texture = LoaderService.getResource('reward_opened').texture;

                    PopupsService.openRewardPopup({ title: 'SUPERSTAY MATTE INK', model: 'model name', discount: 90 })
                })
            }

            let isNotLastLevel = i < lastLevel ? true : false;
            let isLastLevel = i === lastLevel - 1 ? true : false;
            // if (userLevels[`revard_${elements[i].level}`] && userLevels[elements[i].level].score === 0) {
            //     isNotLastLevel = false;
            // }


            const substate = this.createSubstate(element.isRevard, isNotLastLevel, isLastLevel);
            substate.zIndex = 60;
            substate.x = -25;
            substate.y = 50;

            if (isLastLevel) {
                substate.x = substate.x + 30;
                substate.y = substate.y - 30;
            }

            // if (userLevels[`revard_${i - 1}`] && userLevels[`revard_${i - 1}`].isRevard && userLevels[i] && userLevels[i].score > 0) {
            //     const scoreText = this.addScore(userLevels[i].score);
            //     const pts = this.addPtsText(scoreText.text.length);
            //     const time = this.addTime(userLevels[i].time);
            //     container.addChild(scoreText, pts, time);
            // }

            if (userLevels[level] && userLevels[level].score > 0 && !elements[i].isRevard) {
                const scoreText = this.addScore(userLevels[level].score);
                const pts = this.addPtsText(scoreText.text.length);
                const time = this.addTime(userLevels[level].time);
                container.addChild(scoreText, pts, time);
            }

            container.name = `map_element_${i}`;
            container.addChild(substate);
            container.pivot.set(container.width / 2, container.height / 2);
            container.zIndex = 100;

            container.scale.set(0.95);

            this.sortContainerChildren(container);
            mapElements.push(container);
            this.mapElements.addChild(container);
        }

        for (let i = 0; i < points.length; i++) {

            if (i === lastLevel - 1) {
                break;
            }

            if (points[i + 1]) {
                const current = points[i];
                const next = points[i + 1];
                const isLevelComplete = next.isLevelComplete;
                const isReward = elements[i + 1] && elements[i + 1].isRevard ? elements[i + 1].isRevard : false;

                const distance = this.calcDistance(current.x, current.y, next.x, next.y);
                let angle = this.angle(current.x, current.y, next.x, next.y);
                const arrows = isLevelComplete ? Math.round(distance / this.arrowSize.big.height) : Math.round(distance / this.arrowSize.small.height);
                const arrowContainer = new PIXI.Container();
                for (let j = 0; j < arrows; j++) {
                    const arrow = this.createLineSprite(j, isLevelComplete);

                    if (angle > 0) {
                        arrow.texture = isLevelComplete ? LoaderService.getResource('arrow_long_right').texture : LoaderService.getResource('arrow_short_right').texture;
                    } else {
                        arrow.texture = isLevelComplete ? LoaderService.getResource('arrow_long_left').texture : LoaderService.getResource('arrow_short_left').texture;
                    }

                    arrowContainer.addChild(arrow)
                }

                if (angle > 0) {
                    angle = -angle;
                } else {
                    angle = Math.abs(angle);
                }

                arrowContainer.pivot.set(arrowContainer.width, arrowContainer.height)
                arrowContainer.name = `arrow_container_${i}`;
                arrowContainer.y = current.y;
                arrowContainer.x = current.x;
                arrowContainer.zIndex = 50;
                arrowContainer.rotation = angle + 0.05;

                // if (i === lastLevel - 2) {
                //     arrowContainer.rotation = arrowContainer.rotation + 0.15;
                // }

                this.mapElements.addChild(arrowContainer);
            }
        }

        this.mapElements.y = -100;

        this.map.addChild(this.mapElements);

        this.sortContainerChildren(this.mapElements);
        MapStorage.lastLevel = this.lastLevel;
    }

    private addRevardImage(isClimed) {
        let sprite;
        if (isClimed) {
            sprite = new PIXI.Sprite(LoaderService.getResource('reward_opened').texture);
        } else {
            sprite = new PIXI.Sprite(LoaderService.getResource('reward_closed').texture);
        }

        sprite.x = -40;
        sprite.y = -10;

        sprite.width = 200;
        sprite.height = 200;

        sprite.zIndex = 80;
        return sprite;
    }

    private addScore(score) {
        const text = new PIXI.Text(TextHelper.numberWithCommas(score));
        text.style = new PIXI.TextStyle({
            fontFamily: FontsConfig.fonts.Helvetica_Neue,
            fontSize: 45,
            fill: 0xffffff,
            letterSpacing: 4.75,
            fontWeight: 'bold'
        })
        text.y = 210;
        text.x = 20;
        return text;
    }

    private addPtsText(scoreLength) {
        const text = new PIXI.Text(LanguageService.getTranslation('loc_pixi_pts'));
        text.style = new PIXI.TextStyle({
            fontFamily: FontsConfig.fonts.Helvetica_Neue,
            fontSize: 25,
            fill: 0xffffff,
            letterSpacing: 3,
            fontWeight: 'bold'
        })

        text.y = 215;

        if (scoreLength > 5) {
            text.x = 180;
        } else {
            text.x = 150;
        }

        return text;
    }

    private addTime(time) {
        const text = new PIXI.Text(time);
        text.style = new PIXI.TextStyle({
            fontFamily: FontsConfig.fonts.Helvetica_Neue,
            fontSize: 30,
            fill: 0xffffff,
            letterSpacing: 3,
            fontWeight: 'bold'
        })

        text.y = 265;
        text.x = 20;
        text.alpha = 0.7;

        return text;
    }

    private createSubstate(isReward: boolean, isNotLastLevel: boolean, isLastLevel: boolean): PIXI.Sprite {
        const sprite = new PIXI.Sprite();
        sprite.pivot.set(sprite.width / 2, sprite.height / 2);
        sprite.width = 220;
        sprite.height = 220;

        if (!isNotLastLevel) {
            sprite.texture = LoaderService.getResource('grey_substate').texture;
            sprite.width = 105;
            sprite.height = 105;
        } else {
            if (isReward) {
                sprite.texture = LoaderService.getResource('map_reward_substate').texture;
                sprite.width = 160;
                sprite.height = 160;
            }
            if (!isLastLevel) {
                sprite.texture = LoaderService.getResource('map_element_substate').texture;
            }

            if (isLastLevel) {
                sprite.texture = LoaderService.getResource('map_reward_substate').texture;
                sprite.width = 160;
                sprite.height = 160;
            }
        }

        // sprite.pivot.set(sprite.width / 2, sprite.height / 2);

        return sprite;
    }

    private createLineSprite(j, isLevelComplete) {
        const sprite = new PIXI.Sprite(LoaderService.getResource('arrow_long_left').texture);

        if (isLevelComplete) {
            sprite.height = this.arrowSize.big.height;
            sprite.width = this.arrowSize.big.width;
        } else {
            sprite.height = this.arrowSize.small.height;
            sprite.width = this.arrowSize.small.width;
        }
        sprite.y = sprite.height * j;
        return sprite;
    }

    private angle(x1, y1, x2, y2) {
        const dx = x1 - x2;
        const dy = y1 - y2;

        return Math.atan2(dx, dy);
    }

    private calcDistance(x1, y1, x2, y2): number {
        const a = x1 - x2;
        const b = y1 - y2;

        const c = Math.sqrt(a * a + b * b);
        return c;
    }

    private sortContainerChildren(container): void {
        container.children.sort((a, b) => {
            return a.zIndex - b.zIndex;
        });
    }

    private hideMapMenu(): void {
        const menu = document.getElementById('mapMenu');
        menu.style.display = 'none';
    }

    public show(): void {
        console.log('show map');
        
        const container = Main.instance.app.stage.getChildByName('map_screen') as PIXI.Container;
        const map = container.getChildByName('map') as PIXI.Container;
        const app = document.getElementById('app');
        app.style.display = 'block';
        PreloaderHelper.togglePreloader(false);
        // map.y = -map.height + OriginSize.height;
        const btn = document.getElementById('mapBtn');
        btn.style.display = 'flex';
        this.showMapMenu();
        // this.moveMapToLevel();
    }

    public hide(): void {
        const app = document.getElementById('app');
        app.style.display = 'none';
        this.hideMapMenu();
    }

    public destroy(): void {

    }

    protected setPositionMap() {
        const shift = MapConfig.elements[0].y - this.lastElement.y;
        
        if(shift > 0) {
            const shiftMap = this.map.y + shift;
            this.map.y = shiftMap < -1000 ? (shiftMap - 100) : -1000;
        } 
    }

}